import { createAction, props } from '@ngrx/store';
import {
  ContentPage,
  ContentPagePaged,
  ContentSection,
  ContentSectionGroup,
  ContentSectionGroupPaged,
  ContentSectionPaged,
} from '@nrwl/rx-service-content-editor';
import { FormTemplate, SearchModel, SearchType } from '@nrwl/rx-models';

import { Action } from '@ngrx/store';
import { PagerQueryModel } from 'libs/rx-services/src/lib/api/content-editor/pager-query.model';

export enum ContentActionTypes {
  LoadCategories = '[Content] Load Categories',
  LoadCategoriesSuccess = '[Content] Load Categories Success',
  LoadCategoryItem = '[Content] Load Category Item',
  LoadCategoryItemSuccess = '[Content] Load Category Item Success',
  LoadCategoryItems = '[Content] Load Category Items',
  LoadCategoryItemsSuccess = '[Content] Load Category Items Success',
  LoadCategoryItemPages = '[Content] Load Category Item Pages',
  LoadCategoryItemPagesSuccess = '[Content] Load Category Item Pages Success',

  LoadContentPageById = '[Content] LoadContentPageById',
  LoadContentPageByIdSuccess = '[Content] LoadContentPageById Success',

  UpdateMediaDataBuffer = '[Content] Update Media Data In Current Page',

  UpdateContentSectionGroup = '[Content] UpdateContentSectionGroup',
  UpdateContentSectionGroupSuccess = '[Content] UpdateContentSectionGroupSuccess',
  UpdateContentSection = '[Content] UpdateContentSection',
  UpdateContentSectionSuccess = '[Content] UpdateContentSectionSuccess',
  UpdateContentPage = '[Content] UpdateContentPage',
  UpdateContentPageSuccess = '[Content] UpdateContentPageSuccess',

  ArchiveCategory = '[Content] ArchiveCategory',
  ArchiveCategorySuccess = '[Content] ArchiveCategorySuccess',
  ArchiveCategoryItem = '[Content] ArchiveCategoryItem',
  ArchiveCategoryItemSuccess = '[Content] ArchiveCategoryItemSuccess',

  ArchiveSectionPage = '[Content] ArchiveSectionPage',
  ArchiveSectionPageSuccess = '[Content] ArchiveSectionPageSuccess',

  RestoreCategory = '[Content] RestoreCategory',
  RestoreCategorySuccess = '[Content] RestoreCategorySuccess',
  RestoreCategoryItem = '[Content] RestoreCategoryItem',
  RestoreCategoryItemSuccess = '[Content] RestoreCategoryItemSuccess',
  RestoringCategoryItem = '[Content] RestoringCategoryItem',

  CreateCategory = '[Content] Create Category',
  CreateCategorySuccess = '[Content] Create Category Success',

  SkipUpdateContentSectionStore = '[Content] Skip Update Content Section Store',
  AllowUpdateContentSectionStore = '[Content] Allow Update Content Section Store',

  CreateCategoryItem = '[Content] Create Category Item',
  CreateCategoryItemSuccess = '[Content] Create Category Item Success',

  CreateCategoryItemPage = '[Content] Create Category Item Page',
  CreateCategoryItemPageSuccess = '[Content] Create Category Item Page Success',

  CloneCategoryItems = '[Content] CloneCategoryItems',
  CloneCategoryItemsSuccess = '[Content] CloneCategoryItemsSuccess',

  LeftViewMode = '[Content] LeftViewMode',
  RightViewMode = '[Content] RightViewMode',

  SelectCategoryItemById = '[Content] Load Category Item By Id',
  SelectCategoryItemByIdSuccess = '[Content] Load Category Item By Id Success',
  SelectCategories = '[Content] Select Categories',
  SelectCategoriesSuccess = '[Content] Select Categories Success',
  SelectPage = '[Content] Select Content Page',
  SelectPageSuccess = '[Content] Select Content Page Success',
  SearchItems = '[Content] Search Items',
  SearchTemplateItems = '[Content] Search Template Items',
  SetSearchResult = '[Content] Set Search Result',
  SetShowPreview = '[Content] Set Show Preview',
  ToggleSearchResult = '[Content] Toggle Search Result',
  ResetSearch = '[Content] Reset Search',
  ResetSearchSuccess = '[Content] Reset Search Success',
  SortCategory = '[Content] Sort Category',
  SortCategorySuccess = '[Content] Sort Category Success',
  SortCategoryItem = '[Content] Sort Category Item',
  MoveCategoryItem = '[Content] Move Category Item',
  SortCategoryItemSuccess = '[Content] Sort Category Item',
  SortContentPage = '[Content] Sort Content Page',
  SortContentPageSuccess = '[Content] Sort Content Page Success',

  EmptyNewContentSection = '[Content] Empty New Content Section',

  PreviewTemplateSection = '[Content] Preview Template Section',

  Error = '[Content] Error Content',
}

// Load Categories
export const loadCategories = createAction(ContentActionTypes.LoadCategories);

export const loadCategoriesSuccess = createAction(
  ContentActionTypes.LoadCategoriesSuccess,
  props<{ payload: ContentSectionGroupPaged }>(),
);

// Load Category Item
export const loadCategoryItem = createAction(
  ContentActionTypes.LoadCategoryItem,
  props<{ payload: number; searchType: SearchType }>(),
);

export const loadCategoryItemSuccess = createAction(
  ContentActionTypes.LoadCategoryItemSuccess,
  props<{ section: ContentSection; pages: ContentPagePaged; showPreview?: boolean }>(),
);

// Create Category
export const createCategory = createAction(
  ContentActionTypes.CreateCategory,
  props<{ payload: ContentSectionGroup }>(),
);

export const createCategorySuccess = createAction(
  ContentActionTypes.CreateCategorySuccess,
  props<{ payload: ContentSectionGroup }>(),
);

// Update Content Section
export const updateContentSection = createAction(
  ContentActionTypes.UpdateContentSection,
  props<{ payload: ContentSection; isSort?: boolean }>(),
);

export const updateContentSectionSuccess = createAction(
  ContentActionTypes.UpdateContentSectionSuccess,
  props<{ payload: ContentSection }>(),
);

// Archive Actions
export const archiveCategory = createAction(
  ContentActionTypes.ArchiveCategory,
  props<{ payload: any }>(),
);

export const archiveCategorySuccess = createAction(
  ContentActionTypes.ArchiveCategorySuccess,
  props<{ payload: any }>(),
);

// Error handling
export const error = createAction(ContentActionTypes.Error, props<{ payload: any }>());

export class SkipUpdateContentSectionStore implements Action {
  readonly type = ContentActionTypes.SkipUpdateContentSectionStore;
}
export class AllowUpdateContentSectionStore implements Action {
  readonly type = ContentActionTypes.AllowUpdateContentSectionStore;
}

export class EmptyNewContentSection implements Action {
  readonly type = ContentActionTypes.EmptyNewContentSection;
}

export class LoadCategories implements Action {
  readonly type = ContentActionTypes.LoadCategories;
}

export class LoadCategoriesSuccess implements Action {
  readonly type = ContentActionTypes.LoadCategoriesSuccess;
  constructor(public payload: ContentSectionGroupPaged) {}
}

export class UpdateMediaDataBuffer implements Action {
  readonly type = ContentActionTypes.UpdateMediaDataBuffer;
  constructor(public payload: any) {}
}

export class PreviewTemplateSection implements Action {
  readonly type = ContentActionTypes.PreviewTemplateSection;
  constructor(public payload: { template: any; searchType: SearchType }) {}
}

export class SetShowPreview implements Action {
  readonly type = ContentActionTypes.SetShowPreview;
  constructor(public payload: boolean) {}
}

export class LoadCategoryItem implements Action {
  readonly type = ContentActionTypes.LoadCategoryItem;
  constructor(
    public payload: number,
    public searchType: SearchType,
  ) {}
}

export class LoadCategoryItemSuccess implements Action {
  readonly type = ContentActionTypes.LoadCategoryItemSuccess;
  constructor(
    public payload: { section: ContentSection; pages: ContentPagePaged; showPreview?: boolean },
  ) {}
}

export class LoadCategoryItems implements Action {
  readonly type = ContentActionTypes.LoadCategoryItems;
  constructor(public payload: PagerQueryModel) {}
}

export class LoadCategoryItemsSuccess implements Action {
  readonly type = ContentActionTypes.LoadCategoryItemsSuccess;
  constructor(public payload: ContentSection[]) {}
}

export class LoadCategoryItemPages implements Action {
  readonly type = ContentActionTypes.LoadCategoryItemPages;
  constructor(
    public payload: any,
    public searchType: SearchType,
  ) {}
}

export class LoadCategoryItemPagesSuccess implements Action {
  readonly type = ContentActionTypes.LoadCategoryItemPagesSuccess;
  constructor(public payload: any) {}
}

export class LoadContentPageById implements Action {
  readonly type = ContentActionTypes.LoadContentPageById;
  constructor(public payload: number) {}
}

export class LoadContentPageByIdSuccess implements Action {
  readonly type = ContentActionTypes.LoadContentPageByIdSuccess;
  constructor(public payload: ContentPage) {}
}

export class SelectCategoryItemById implements Action {
  readonly type = ContentActionTypes.SelectCategoryItemById;
  constructor(public payload: number) {}
}

export class SelectCategoryItemByIdSuccess implements Action {
  readonly type = ContentActionTypes.SelectCategoryItemByIdSuccess;
  constructor(public payload: number) {}
}

export class CreateCategory implements Action {
  readonly type = ContentActionTypes.CreateCategory;
  readonly info = 'Creating Content Section...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: ContentSectionGroup) {}
}

export class CreateCategorySuccess implements Action {
  readonly type = ContentActionTypes.CreateCategorySuccess;
  readonly success = 'Content Section Group successfully created.';
  constructor(public payload: ContentSectionGroup) {}
}

export class CreateCategoryItem implements Action {
  readonly type = ContentActionTypes.CreateCategoryItem;
  readonly info = 'Creating Content Section...';
  readonly error = 'An error occured while processing your request.';
  constructor(
    public payload: ContentSection,
    public loadInEditor: boolean = false,
  ) {}
}

export class CreateCategoryItemSuccess implements Action {
  readonly type = ContentActionTypes.CreateCategoryItemSuccess;
  readonly success = 'Content Section successfully created.';
  constructor(
    public payload: ContentSection,
    public loadInEditor: boolean = false,
  ) {}
}

export class CreateCategoryItemPage implements Action {
  readonly type = ContentActionTypes.CreateCategoryItemPage;
  readonly info = 'Creating Content Section Page...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: ContentPage) {}
}

export class CreateCategoryItemPageSuccess implements Action {
  readonly type = ContentActionTypes.CreateCategoryItemPageSuccess;
  readonly success = 'Content Section Page successfully created.';
  constructor(public payload: any) {}
}

export class CloneCategoryItems implements Action {
  readonly type = ContentActionTypes.CloneCategoryItems;
  readonly info = 'Creating Content Section(s)...';
  readonly error = 'An error occured while processing your request.';
  constructor(
    public category: ContentSectionGroup,
    public categoryItems: ContentSection[],
  ) {}
}

export class CloneCategoryItemsSuccess implements Action {
  readonly type = ContentActionTypes.CloneCategoryItemsSuccess;
  readonly success = 'Content Section(s) successfully created.';
  constructor(public categoryItems: ContentSection[]) {}
}

export class UpdateContentSectionGroup implements Action {
  readonly type = ContentActionTypes.UpdateContentSectionGroup;
  readonly info = 'Updating Content Section Group...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: { item: ContentSectionGroup; fields?: string[] }) {}
}

export class UpdateContentSectionGroupSuccess implements Action {
  readonly type = ContentActionTypes.UpdateContentSectionGroupSuccess;
  readonly success = 'Content Section Group successfully updated.';
  constructor(public payload: any) {}
}

export class UpdateContentSection implements Action {
  readonly type = ContentActionTypes.UpdateContentSection;
  readonly info = 'Updating Content Section...';
  readonly error = 'An error occured while processing your request.';
  constructor(
    public payload: any,
    isSort: boolean = false,
  ) {}
}

export class UpdateContentSectionSuccess implements Action {
  readonly type = ContentActionTypes.UpdateContentSectionSuccess;
  readonly success = 'Content Section successfully updated.';
  constructor(public payload: any) {}
}

export class UpdateContentPage implements Action {
  readonly type = ContentActionTypes.UpdateContentPage;
  readonly info = 'Updating Content Section Page...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: ContentPage) {}
}

export class UpdateContentPageSuccess implements Action {
  readonly type = ContentActionTypes.UpdateContentPageSuccess;
  readonly success = 'Content Section Page successfully updated.';
  constructor(public payload: ContentPage) {}
}

export class ArchiveCategory implements Action {
  readonly type = ContentActionTypes.ArchiveCategory;
  readonly info = 'Archiving Content Section Group...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: any) {}
}

export class ArchiveCategorySuccess implements Action {
  readonly type = ContentActionTypes.ArchiveCategorySuccess;
  readonly success = 'Content Section Group successfully archived.';
  readonly error = 'An error occured while archiving Content Section Group.';
  constructor(public payload: any) {}
}

export class ArchiveCategoryItem implements Action {
  readonly type = ContentActionTypes.ArchiveCategoryItem;
  readonly info = 'Archiving Content Section...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: any) {}
}

export class ArchiveCategoryItemSuccess implements Action {
  readonly type = ContentActionTypes.ArchiveCategoryItemSuccess;
  readonly success = 'Content Section Group successfully archived.';
  readonly error = 'An error occured while archiving Content Section Group.';
  constructor(public payload: any) {}
}

export class ArchiveSectionPage implements Action {
  readonly type = ContentActionTypes.ArchiveSectionPage;
  readonly info = 'Deleting Content Section Page...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: any) {}
}

export class ArchiveSectionPageSuccess implements Action {
  readonly type = ContentActionTypes.ArchiveSectionPageSuccess;
  readonly success = 'Content Section Page successfully Delete.';
  readonly error = 'An error occured while deleting Content Section page.';
  constructor(public payload: any) {}
}

export class RestoreCategory implements Action {
  readonly type = ContentActionTypes.RestoreCategory;
  readonly info = 'Restoring Content Section Group...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: any) {}
}

export class RestoreCategorySuccess implements Action {
  readonly type = ContentActionTypes.RestoreCategorySuccess;
  constructor(public payload: any) {}
}

export class RestoreCategoryItem implements Action {
  readonly type = ContentActionTypes.RestoreCategoryItem;
  readonly info = 'Restoring Content Section...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: any) {}
}
export class RestoringCategoryItem implements Action {
  readonly type = ContentActionTypes.RestoringCategoryItem;
  readonly info = 'Restoring Content Section...';
  readonly error = 'An error occured while processing your request.';
  constructor(public payload: any) {}
}

export class RestoreCategoryItemSuccess implements Action {
  readonly type = ContentActionTypes.RestoreCategoryItemSuccess;
  constructor(public payload: any) {}
}
// selection: any, reset?: boolean
export class SelectCategories implements Action {
  readonly type = ContentActionTypes.SelectCategories;
  constructor(
    public selection: [{ category: number; searchType: SearchType }?],
    public searchType: SearchType,
    public reset?: boolean,
  ) {}
  // constructor(
  //     public payload?: number[],
  //     public searchType?: SearchType,
  //     public reset?: boolean
  // ) {}
}

// Call select action from effect
export class SelectCategoriesSuccess implements Action {
  readonly type = ContentActionTypes.SelectCategoriesSuccess;
  constructor(public payload?: [{ category: number; searchType: SearchType }?]) {}
}

export class SelectPage implements Action {
  readonly type = ContentActionTypes.SelectPage;
  constructor(public payload?: ContentPage) {}
}

// Call select action from effect
export class SelectPageSuccess implements Action {
  readonly type = ContentActionTypes.SelectPageSuccess;
  constructor(public payload?: any) {}
}

export class SortCategory implements Action {
  readonly type = ContentActionTypes.SortCategory;
  constructor(
    public payload: any, // sectionGroup
    public fromIndex: number,
    public toIndex: number,
    public searchType: SearchType,
  ) {}
}

export class SortCategorySuccess implements Action {
  readonly type = ContentActionTypes.SortCategorySuccess;
  constructor(public payload: any[]) {} // sectionGroup
}

export class SortCategoryItem implements Action {
  readonly type = ContentActionTypes.SortCategoryItem;
  constructor(
    public payload: ContentSection,
    public fromIndex: number,
    public toIndex: number,
    public searchType: SearchType,
    public templateItems?: ContentSection[],
  ) {}
}

export class MoveCategoryItem implements Action {
  readonly type = ContentActionTypes.MoveCategoryItem;
  constructor(
    public payload: ContentSection,
    public new_section_group: number,
    public fromIndex: number,
    public toIndex: number,
    public searchType: SearchType,
    public templateItems?: ContentSection[],
  ) {}
}

export class SortCategoryItemSuccess implements Action {
  readonly type = ContentActionTypes.SortCategoryItemSuccess;
  constructor(public payload: any[]) {}
}

export class SortContentPage implements Action {
  readonly type = ContentActionTypes.SortContentPage;
  constructor(
    public payload: ContentPage,
    public fromIndex: number,
    public toIndex: number,
  ) {}
}

export class SortContentPageSuccess implements Action {
  readonly type = ContentActionTypes.SortContentPageSuccess;
  constructor(public payload: any[]) {}
}

export class SearchItems implements Action {
  readonly type = ContentActionTypes.SearchItems;
  constructor(public payload: SearchModel) {}
}

export class SearchTemplateItems implements Action {
  readonly type = ContentActionTypes.SearchTemplateItems;
  constructor(public payload: PagerQueryModel) {}
}

export class SetSearchResult implements Action {
  readonly type = ContentActionTypes.SetSearchResult;
  constructor(public payload: SearchModel) {}
}

export class ToggleSearchResult implements Action {
  readonly type = ContentActionTypes.ToggleSearchResult;
  constructor(public payload: SearchModel) {}
}

export class ResetSearch implements Action {
  readonly type = ContentActionTypes.ResetSearch;
  constructor(public payload: SearchType) {}
}

export class ResetSearchSuccess implements Action {
  readonly type = ContentActionTypes.ResetSearchSuccess;
  constructor(public payload: SearchType) {}
}

export class LeftViewMode implements Action {
  readonly type = ContentActionTypes.LeftViewMode;
  constructor(public payload: any) {}
}

export class RightViewMode implements Action {
  readonly type = ContentActionTypes.RightViewMode;
  constructor(public payload: any) {}
}

export class Error implements Action {
  readonly type = ContentActionTypes.Error;
  constructor(public payload: any) {}
}

export type ContentActions = ReturnType<
  | typeof loadCategories
  | typeof loadCategoriesSuccess
  | typeof loadCategoryItem
  | typeof loadCategoryItemSuccess
  | typeof createCategory
  | typeof createCategorySuccess
  | typeof updateContentSection
  | typeof updateContentSectionSuccess
  | typeof archiveCategory
  | typeof archiveCategorySuccess
  | typeof error
  // ... add all other action creators
>;
